/*
 * One-tap add for [data-spk-add="<variant id>"] buttons (cart cross-sell banner, empty cart state).
 * In the drawer: re-renders it through the theme's own cart-drawer.renderContents (sections API).
 * Elsewhere (cart page): reloads the cart page.
 */
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-spk-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    btn.disabled = true;
    var drawer = btn.closest('cart-drawer');
    fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: parseInt(btn.getAttribute('data-spk-add'), 10), quantity: 1 }],
        sections: drawer ? 'cart-drawer,cart-icon-bubble' : undefined
      })
    }).then(function (r) {
      if (!r.ok) throw new Error('add ' + r.status);
      return r.json();
    }).then(function (res) {
      if (drawer && typeof drawer.renderContents === 'function' && res.sections) {
        drawer.classList.remove('is-empty');
        drawer.renderContents(res);
      } else {
        window.location.href = '/cart';
      }
    }).catch(function (err) {
      btn.disabled = false;
      if (window.console) console.error('[spark-cart-extras]', err);
    });
  });
})();
